import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MessageDetailsPageModule } from 'src/app/pages/experience/messages/message-details/message-details.module';
import { MessagesPageModule } from 'src/app/pages/experience/messages/messages/messages.module';

import { MobileComponent } from './mobile.component';

@NgModule({
    imports: [
        IonicModule.forRoot(),
        MessagesPageModule,
        CommonModule,
        MessageDetailsPageModule,
        AppRoutingModule
    ],
    declarations: [
        MobileComponent
    ],
    exports: [MobileComponent]
})
export class MobileModule {}
